import React from 'react';
import Icon from '../../Icon';
import { translate } from '../../../Services/translation';

interface InfoContainerProps {
  company?: string;
  address?: string;
  zip?: string;
  city?: string;
  country?: string;
  icon: any;
  title?: string;
  phone?: string;
  email?: string;
  name?: string;
}

const InfoContainer = ({
  company,
  address,
  zip,
  city,
  country,
  icon,
  title,
  phone,
  email,
  name,
}: InfoContainerProps) => {
  return (
    <div className="flex flex-col gap-2">
      {title && <div className="text-lg font-bold">{title}</div>}
      <div className="flex flex-1 gap-2 rounded border border-solid border-gray-900 bg-gray-50 p-4">
        <Icon name={icon} className="h-6 w-6" />
        <div className="flex flex-col gap-2">
          {company && <span className="font-bold">{company}</span>}
          {name && <span className="font-bold">{name}</span>}
          {phone && (
            <span>
              {translate('general.phone')}: {phone}
            </span>
          )}
          {email && (
            <span>
              {translate('general.email')}: {email}
            </span>
          )}
          {address && <span>{address}</span>}

          <span>
            {zip && zip} {city && city}
          </span>

          {country && <span>{country}</span>}
        </div>
      </div>
    </div>
  );
};

export default InfoContainer;
